import React, { Component, Fragment } from "react";
import utils from "../../../utils/utils";

export default class TabelaFaculdade extends Component {

    constructor(props) {
        super(props);
    }

    calculaTotal = (dados) => {
        
        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
        }

        if(dados) {
            Object.keys(dados.modalidades).map((modalidade, i) => {
                if(modalidade.indexOf("Graduaç") === -1 && modalidade.indexOf("Extensão") === -1) return;
                total["matricula_regimental"]     += dados.modalidades[modalidade]["matricula_regimental"]
                total["matricula_nao_regimental"] += dados.modalidades[modalidade]["matricula_nao_regimental"]
                total["matricula_pago"]           += dados.modalidades[modalidade]["matricula_pago"]
                total["hora_regimental"]          += dados.modalidades[modalidade]["hora_regimental"]
                total["hora_nao_regimental"]      += dados.modalidades[modalidade]["hora_nao_regimental"]
                total["hora_pago"]                += dados.modalidades[modalidade]["hora_pago"]
            });
        }

        return total;

    }

    render() {
        let { dados, mesSelecionado, radioChecked, isAcumulado, acumulado } = this.props;
        let totais;
        
        if(isAcumulado) {
            dados = JSON.parse(JSON.stringify(acumulado))
        }

        let valor = dados[mesSelecionado][dados[mesSelecionado].length-1];
        let total = this.calculaTotal(valor);

        return (
            <Fragment>
                
                <tr>
                    <td colSpan="19" style={{ textAlign: "center", fontWeight: "600", backgroundColor: "#c5c0ad", fontSize: "14px" }}>FACULDADE</td>
                </tr>
                {Object.keys(valor.modalidades).map((modal, j) => {

                    // Verifica Faculdade
                    if(modal.indexOf("Graduaç") === -1 && modal.indexOf("Extensão") === -1) return;

                    return (
                        <tr>
                            <td style={{ backgroundColor: "#c5c0ad" }}>{modal}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_regimental"])}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valor.modalidades[modal]["matricula_pago"] + valor.modalidades[modal]["matricula_nao_regimental"] + valor.modalidades[modal]["matricula_regimental"])}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_regimental"])}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_nao_regimental"])}</td>
                            <td>{utils.formataNumero(valor.modalidades[modal]["hora_pago"])}</td>
                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valor.modalidades[modal]["hora_pago"] + valor.modalidades[modal]["hora_nao_regimental"] + valor.modalidades[modal]["hora_regimental"])}</td>
                        </tr>
                    )
                })
                }
                
                <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad"  }}>
                    <td>Total</td>
                    <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                    <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["matricula_pago"])}</td>
                    <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                    <td>{utils.formataNumero(total["hora_regimental"])}</td>
                    <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                    <td>{utils.formataNumero(total["hora_pago"])}</td>
                    <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                </tr>

            </Fragment>
        )
    }
}